export function getJson(url, data = {}) {

	return new Promise((resolve, reject) => {
		let params = jsonToStringParams(data)

		url += ((url.indexOf('?') == -1 ? '?' : '&') + params)

    	fetch(url, {
    		method: 'GET', 
    		mode: 'cors', 
			redirect: 'follow',
    		credentials: 'include', 
    		headers: new Headers({'Content-Type': 'application/json'}) 
    	}).then((response) => {
    		var contentType = response.headers.get("content-type");
	  		if(contentType && contentType.indexOf("application/json") !== -1) {
	    		return response.json().then(function(json) {
	      			resolve(json)
	   			});
	  		} else {
    			try {
					response.json().then(res => resolve(res))
				} catch(error) {
					resolve(response)
				}
	  		}
    	}).catch((err) => {
    		return reject(err)
    	})

    })
}

export function postJson(url, data = {}) {

	return new Promise((resolve, reject) => {
    	fetch(url, {
    		body: JSON.stringify(body),
    		method: 'POST', 
    		mode: 'cors', 
			redirect: 'follow',
    		credentials: 'include',
    		headers: new Headers({'Content-Type': 'application/json'}) 
    	}).then((response) => {
    		var contentType = response.headers.get("content-type");
	  		if(contentType && contentType.indexOf("application/json") !== -1) {
	    		return response.json().then(function(json) {
	      			resolve(json)
	   			});
	  		} else {
	    		//console.log("Oops, we haven't got JSON!");
	    		resolve(res)
	  		}
    	}).catch((err) => {
    		return reject(err)
    	})

    })
}

export function jsonToStringParams(data = {}) {
	let url = Object.keys(data).map(function(k) {
    	return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
	}).join('&')

	return url
}

var request = {
	getJson,
	postJson,
	jsonToStringParams
}

export default request


/** WEBPACK FOOTER **
 ** ./main/assets/article/js/src/request.js
 **/